import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { CommonModule } from '@angular/common';
import {
  Labels,
  Messages
} from '../../modules/shared/components/vip-offer-list/constant';
import { META_MASK_URL } from '../../constants/constant';

@Component({
  selector: 'app-nft-unlock-modal',
  templateUrl: './nft-unlock-modal.component.html',
  styleUrls: ['./nft-unlock-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, AlertModalComponent]
})
export class NftUnlockModalComponent {
  @Input() contentType: string = 'offer';
  @Input() modalHeader: string;
  @Input() headerType = '';
  @Input() modalOptions = {};

  @Output() confirmed = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @ViewChild('nftUnlockOffer') nftUnlockModal;

  labels = Labels;
  messages = Messages;
  metaMaskUrl = META_MASK_URL;
  confirmNftOffer() {
    this.confirmed.emit();
  }
  openModal() {
    this.nftUnlockModal?.openModal();
  }
  closeModal() {
    this.nftUnlockModal?.closeModal();
  }

  handleCancel() {
    this.canceled.emit();
  }
}
